import React from 'react'

const DetailTable = ({ headerName, data }) => {
  const renderValue = (value) => {
    if (typeof value === 'string') {
      if (value.startsWith('http')) {
        return `<a href="${value}" target="_blank" rel="noopener noreferrer" style="color: #0066cc; text-decoration: none;">${value}</a>`
      }
      // Handle line breaks in description
      if (value.includes('\n')) {
        return value.split('\n').map(line => line).join('<br/>')
      }
    }
    return value || ''
  }

  const tableStyle = `
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;
    font-family: Arial, sans-serif;
    font-size: 14px;
  `

  const headerStyle = `
    background-color: #87bdff;
    padding: 4px;
    color: #000;
    text-align: center;
    border: 1px solid #000;
    font-weight: bold;
    font-size: 14px;
  `

  const keyCellStyle = `
    background-color: #87bdff;
    padding: 4px;
    border: 1px solid #000;
    vertical-align: top;
    width: 200px;
    font-size: 14px;
  `

  const valueCellStyle = `
    background-color: #ffffff;
    padding: 4px;
    border: 1px solid #000;
    vertical-align: top;
    font-size: 14px;
  `

  const getRowsForValue = (key, value) => {
    // Special handling for Eligible Qualification
    if (key === 'Eligible Qualification' && typeof value === 'string' && value.includes('(And)')) {
      const parts = value.split('(And)');
      const rowCount = parts.length * 2 - 1; // Calculate total rows (each part + 'And' between them except after last part)
      
      // Calculate the rowspan for the key cell
      const rowSpan = rowCount;
      
      let result = '';
      
      // Build all the rows
      for (let i = 0; i < parts.length; i++) {
        // First row includes the key with rowspan
        if (i === 0) {
          result += `
            <tr>
              <td style="${keyCellStyle}" rowspan="${rowSpan}">${key}</td>
              <td style="${valueCellStyle}">${renderValue(parts[i].trim())}</td>
            </tr>
          `;
        } else {
          // For subsequent parts, add an 'And' row first, then the part
          result += `
            <tr>
              <td style="${valueCellStyle}">And</td>
            </tr>
            <tr>
              <td style="${valueCellStyle}">${renderValue(parts[i].trim())}</td>
            </tr>
          `;
        }
      }
      
      return result;
    } else {
      // Default handling for other fields
      return `
        <tr>
          <td style="${keyCellStyle}">${key}</td>
          <td style="${valueCellStyle}">${renderValue(value)}</td>
        </tr>
      `;
    }
  };

  const html = `
    <table style="${tableStyle}">
      <tbody>
        <tr>
          <td colspan="2" style="${headerStyle}">${headerName}</td>
        </tr>
        ${Object.entries(data).map(([key, value]) => getRowsForValue(key, value)).join('')}
      </tbody>
    </table>
  `

  // For React rendering in the app
  if (typeof document !== 'undefined') {
    return (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    )
  }

  // For email template
  return html
}

export default DetailTable
